/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Bonuses } from '../../models/bonuses';

export interface GetLoyaltyProgramBonuses$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
}

export function getLoyaltyProgramBonuses(http: HttpClient, rootUrl: string, params: GetLoyaltyProgramBonuses$Params, context?: HttpContext): Observable<StrictHttpResponse<Bonuses>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyProgramBonuses.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Bonuses>;
    })
  );
}

getLoyaltyProgramBonuses.PATH = '/loyalty/programs/{programId}/bonuses';
